import SelectStyled from "@/components/SelectStyled";
import { MenuItem } from "@mui/material";

const TimeMinuteSelector = ({
  defaultValue,
  onChange,
  ...props
}) => {
  const handleInputChanged = (event, value = null) => {
    if (onChange) {
      onChange(event, value);
    }
  };

  const minutes = () => {
    let allMinutes = [];
    for (let m = 0; m <= 60; m += 5) {
      const minute = m < 10 ? `0${m}` : m;
      allMinutes = [...allMinutes, minute];
    }

    return allMinutes;
  };

  return (
    <SelectStyled
      values={minutes}
      value={defaultValue}
      onChange={handleInputChanged}
      menuProps="LimitHeight"
      allowEmpty={true}
    >
      {minutes().map((option, key) => (
        <MenuItem value={option} key={key}>
          {option}
        </MenuItem>
      ))}
    </SelectStyled>
  );
};

export default TimeMinuteSelector;
